import { SourceType } from 'module/api/filter/types';
import { useEmailFieldsAsFilterableField } from 'helpers/fields/email-fields/fields';
import { meetingBlockResponseToLookup } from '../../../shared/response-renderer-utils';
import { SharedDetailBlockPromptSection } from '../../shared-detail-blocks/prompt-section';
import { EmailDetailsSectionComponentProps } from '../types';

export const EmailDetailsPromptSection = ({
  node,
  onDone,
  onOpen,
  onRemove,
  onUndo,
  allowResolve,
  contentEditable,
  pageType,
  pageTriggerListFilter,
}: EmailDetailsSectionComponentProps) => {
  const { fields: emailFields, loading: isLoading } =
    useEmailFieldsAsFilterableField();

  return (
    <SharedDetailBlockPromptSection
      node={node}
      sourceType={SourceType.Email}
      useFieldsHook={() => ({ fields: emailFields, loading: isLoading })}
      defaultTitleKey="rich_text_editor_sections_email_details"
      titlePlaceholderKey="rich_text_editor_sections_email_details_title_placeholder"
      fieldLabelKey="grouped_filter.email"
      responseToLookupFunction={meetingBlockResponseToLookup}
      onDone={onDone}
      onUndo={onUndo}
      onOpen={onOpen}
      contentEditable={contentEditable}
      onRemove={onRemove}
      allowResolve={allowResolve}
      pageType={pageType}
      pageTriggerListFilter={pageTriggerListFilter}
    />
  );
};
